<template>
  <div>
    <CRow>
      <!-- Sidebar -->
      <CCol md="3">
        <CCard>
          <CCardHeader>
            <i class="fa fa-filter"></i>&nbsp; Filtrar por
            <button
              type="button"
              class="btn btn-sm btn-info text-white float-right pr-2"
              @click="mtd_open_modal(true,'store')"
              :disabled="cpButtonNew"
            >
              <i class="fas fa-plus"></i> Nuevo
            </button>
            <button
              @click="mtdBack"
              type="button"
              class="btn btn-sm text-white float-right"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Inicio
            </button>
            
          </CCardHeader>
          <CCardBody>
            <cSelectForm
              label="Seleccione una Sede"
              :options="data_campus"
              placeholder="Escoja una Sede"
              :value.sync="filter.campu"
              @change="mtdViewFloors"
            />

            <div v-if="data_floors.length">
              <CButton
                v-for="(item, index) in data_floors"
                :key="index"
                class="w-100 mt-2"
                :color="item.value === selectFloor ? 'primary' : 'secondary'"
                @click="mtdSelectFloorAndLoad(item)"
              >
                {{ item.label }}
              </CButton>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- Plano -->
      <CCol md="9">
        <CCard>
          <CCardBody>
            <div class="mb-2 font-weight-bold">Mesas por ubicar:</div>
            <!-- LISTA DE MESAS SIN POSICIÓN -->
            <div v-if="unplacedTables.length" class="unplaced-list mb-3">
              <draggable
                v-model="unplacedTables"
                :options="{ group: 'mesas' }"
                class="d-flex flex-wrap"
                :disabled="true"
              >
                <CButton
                  v-for="(mesa, index) in unplacedTables"
                  :key="mesa.id"
                  class="border rounded px-3 py-2 text-white mr-2 mb-2"
                  :color="mesa.position == true ? 'success' : 'info'"
                  @mousedown="startCanvasDrop(mesa, index)"
                  style="cursor: grab"
                >
                  {{ mesa.Nombre }}
                </CButton>
              </draggable>
            </div>

            <!-- CANVAS DE UBICACIÓN -->
            <div
              class="position-relative border rounded p-2 mb-4"
              style="height: 500px; background-color: #f8f9fa"
              @mousemove="handleMouseMove"
              @mouseup="handleMouseUp"
            >
              <draggable
                v-model="placedTables"
                :options="{ group: 'mesas', animation: 200 }"
              >
                <button
                  v-for="(mesa, index) in placedTables"
                  :key="mesa.id"
                  type="button"
                  class="position-absolute btn btn-primary"
                  :style="mtdGetMesaStyle(mesa)"
                  @mousedown="startDrag(mesa, $event)"
                >
                  <div
                    class="d-flex justify-content-between align-items-center w-100"
                  >
                    <span>{{ mesa.Nombre }}</span>
                    <span class="ml-2" @click.stop="removeMesa(mesa, index)">
                      <i
                        class="fas fa-times text-danger ml-2"
                        style="cursor: pointer"
                      ></i>
                    </span>
                  </div>
                </button>
              </draggable>
            </div>

            <CButton color="success" class="mt-3" @click="savePositions">
              Guardar posiciones
            </CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="table.name"
          />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="table.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Mesa'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import cSelectForm from "../../shared/inputs/cSelect.vue";
import { mapActions } from "vuex";
import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import CModalForm from "../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../../components/shared/modals/cModalDelete.vue";
import CSwitchVue from '../../shared/switch/CSwitch.vue';

export default {
  components: {
    draggable,
    cSelectForm,
    CTableWrapper, CModalForm, cModalDelete, CSwitchVue
  },
  data() {
    return {
      prefix: 'tables',
      data_campus: [],
      data_floors: [],
      selectFloor: null,
      placedTables: [],
      unplacedTables: [],
      filter: {
        campu: null,
      },
      dragging: null,
      offset: { x: 0, y: 0 },
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      table: {
        id: "",
        name: "",
        user_id: this.$store.getters.get__user_id,
        company_id: 1,
        campu_id: "",
        floor_id: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      componentKey: 0,
    };
  },
  computed: {
    cpStatus: function () {
      if (this.table.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.table.name != "") return false;
      return true;
    },
    cpButtonNew (){
      if (this.table.campu_id != "" && this.table.floor_id != "") return false;
      return true;
    }
  },
  created() {
    this.mtdLoadCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtdLoadCampus() {
      this.get({
        url: this.$store.getters.get__url + "/campus/company",
        token: this.$store.getters.get__token,
      }).then((res) => {
        const company = res.data.find((c) => c.id == 1);
        if (company && company.campu) {
          this.data_campus = company.campu
            .filter((c) => c.state == 1)
            .map((c) => ({ label: c.name, value: c.id }));
        }
      });
    },
    mtdViewFloors() {
      this.get({
        url: `${this.$store.getters.get__url}/floors/byCampu/${this.filter.campu}`,
        token: this.$store.getters.get__token,
      }).then((res) => {
        this.data_floors = res.data.map((f) => ({
          label: f.name,
          value: f.id,
        }));
        this.table.campu_id=this.filter.campu;
        this.unplacedTables = [];
        this.placedTables = [];
      });
    },
    mtdSelectFloorAndLoad(floor) {
      this.selectFloor = floor.value;
      this.table.floor_id = this.selectFloor;
      this.mtdLoadTables();
    },
    mtdLoadTables() {
      this.get({
        url: `${this.$store.getters.get__url}/tables/index/${this.selectFloor}`,
        token: this.$store.getters.get__token,
      }).then((res) => {
        const mesas = res.data.data;
        this.placedTables = [];
        this.unplacedTables = [];

        mesas.forEach((mesa) => {
          if (mesa.x != null || mesa.y != null) {
            this.placedTables.push({ ...mesa });
          }
          this.unplacedTables.push(mesa);
        });
      });
    },
    mtdGetMesaStyle(mesa) {
      return {
        left: mesa.x + "px",
        top: mesa.y + "px",
        cursor: "move",
      };
    },
    startDrag(mesa, event) {
      this.dragging = mesa;
      this.offset.x = event.clientX - mesa.x;
      this.offset.y = event.clientY - mesa.y;
    },
    handleMouseMove(event) {
      if (this.dragging) {
        this.dragging.x = event.clientX - this.offset.x;
        this.dragging.y = event.clientY - this.offset.y;
      }
    },
    handleMouseUp() {
      this.dragging = null;
    },
    savePositions() {
      const payload = this.placedTables.map((mesa) => ({
        id: mesa.Id,
        x: Math.round(mesa.x),
        y: Math.round(mesa.y),
      }));

      this.post({
        url: `${this.$store.getters.get__url}/tables/update-positions/${this.selectFloor}`,
        token: this.$store.getters.get__token,
        params: payload,
      })
        .then(() => {
          Swal.fire({
            title: "Ubicación guardada",
            icon: "success",
          });
        })
        .catch(() => {
          Swal.fire({
            title: "Error",
            icon: "error",
          });
        });
    },
    startCanvasDrop(mesa, pos) {
      const item = this.unplacedTables[pos];
      if (!item.position) {
        const mesaClon = {
          ...mesa,
          x: 20 + Math.random() * 100,
          y: 20 + Math.random() * 100,
        };
        this.placedTables.push(mesaClon);
        this.unplacedTables[pos].position = true;
      }else{
        this.mtd_show(mesa.Id);
      }
    },
    removeMesa(mesa, pos) {
      this.placedTables = this.placedTables.filter((it, index) => index != pos);
      this.unplacedTables.forEach((element) => {
        if (element.Id == mesa.Id) {
          element.x = null;
          element.y = null;
          element.position = false;
        }
      });
    },
    /*** CRUD */
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nueva Mesa")
        : (this.modal.title = "Editar Mesa");
      action == "store"
        ? (this.table = {
            id: "",
            name: "",
            user_id: this.$store.getters.get__user_id,
            company_id:1,
            company_id: 1,
            campu_id: this.table.campu_id,
            floor_id: this.selectFloor,
            state: "",
          })
        : (this.table = this.table);
      if (this.modal.action != "store") {
        this.componentKey += 1;
      } else {
        // this.data_campus = []
        // this.data_floors = []
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.table,
      })
        .then((response) => {
          let color = "success";
          let message = "";
          if (response.data.state == 1) {
            Swal.fire({
              title: "Mesa ya resgistrada",
              icon: "info",
            });
          } else {
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
            } else {
              message = "EDITADO CORRECTAMENTE";
            }
            this.mtdLoadTables();
            Swal.fire({
              title: message,
              icon: color,
            });
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            name: "",
          };
          this.dataStore = response.all;
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.table = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          this.dataStore = response.all;
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.table.state = payload == true ? 1 : 0;
    },
  },
};
</script>

<style scoped>
.canvas-area {
  position: relative;
  width: 100%;
  height: 300px;
  border: 2px dashed #ccc;
  background-color: #fdfdfd;
  overflow: hidden;
}
.unplaced-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  border: 1px dashed #999;
  background: #f8f8f8;
  border-radius: 8px;
}

.unplaced-list .title {
  width: 100%;
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
